import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 * Automatically scrolls to the top of a scroll container when the route changes.
 *
 * @param {React.RefObject} containerRef - Ref to the scrollable container div
 */
const ScrollToTop = ({ containerRef }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the container to top whenever the pathname changes
    if (containerRef?.current) {
      containerRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [pathname, containerRef]);

  return null;
};

export default ScrollToTop;
